import * as ambassadorWixInvoicesInvoicesV4Invoice from './invoices-invoices-v4-invoice-invoices.http.js';
import * as ambassadorWixInvoicesInvoicesV4InvoiceTypes from './invoices-invoices-v4-invoice-invoices.types.js';
import * as ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes from './invoices-invoices-v4-invoice-invoices.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createInvoice(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.CreateInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.CreateInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.CreateInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.CreateInvoiceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.createInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getInvoice(): __PublicMethodMetaInfo<
  'GET',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.GetInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.GetInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.GetInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.GetInvoiceResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.getInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/invoices/{invoiceId}',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateInvoice(): __PublicMethodMetaInfo<
  'PATCH',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.UpdateInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.UpdateInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.UpdateInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.UpdateInvoiceResponse
> {
  const payload = { invoice: { id: ':invoiceId' } } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.updateInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v4/invoices/{invoice.id}',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteInvoice(): __PublicMethodMetaInfo<
  'DELETE',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.DeleteInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.DeleteInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.DeleteInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.DeleteInvoiceResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.deleteInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v4/invoices/{invoiceId}',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryInvoices(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.QueryInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.QueryInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.QueryInvoicesResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.QueryInvoicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.queryInvoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/invoices/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchInvoices(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.SearchInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.SearchInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.SearchInvoicesResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.SearchInvoicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.searchInvoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/invoices/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function sendInvoice(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.SendInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.SendInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.SendInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.SendInvoiceResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.sendInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/send',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function publishInvoice(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.PublishInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.PublishInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.PublishInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.PublishInvoiceResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.publishInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/publish',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function voidInvoice(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.VoidInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.VoidInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.VoidInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.VoidInvoiceResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.voidInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/void',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function archiveInvoice(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.ArchiveInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.ArchiveInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.ArchiveInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.ArchiveInvoiceResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.archiveInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/archive',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function unarchiveInvoice(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.UnarchiveInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.UnarchiveInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.UnarchiveInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.UnarchiveInvoiceResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.unarchiveInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/unarchive',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function initiatePayment(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.InitiatePaymentRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.InitiatePaymentRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.InitiatePaymentResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.InitiatePaymentResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.initiatePayment(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/initiate-payment',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function enableInvoicePayments(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.EnableInvoicePaymentsRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.EnableInvoicePaymentsRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.EnableInvoicePaymentsResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.EnableInvoicePaymentsResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.enableInvoicePayments(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/enable-payments',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generatePdfDocument(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.GeneratePdfDocumentRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.GeneratePdfDocumentRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.GeneratePdfDocumentResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.GeneratePdfDocumentResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.generatePdfDocument(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/generate-pdf-document',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function markInvoiceAsViewed(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.MarkInvoiceAsViewedRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.MarkInvoiceAsViewedRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.MarkInvoiceAsViewedResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.MarkInvoiceAsViewedResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.markInvoiceAsViewed(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/mark-as-viewed',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function markInvoiceAsSent(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.MarkInvoiceAsSentRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.MarkInvoiceAsSentRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.MarkInvoiceAsSentResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.MarkInvoiceAsSentResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.markInvoiceAsSent(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/mark-as-sent',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function calculateInvoice(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.CalculateInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.CalculateInvoiceRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.CalculateInvoiceResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.CalculateInvoiceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.calculateInvoice(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/calculate-invoice',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getLatestInvoiceNumber(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.GetLatestInvoiceNumberRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.GetLatestInvoiceNumberRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.GetLatestInvoiceNumberResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.GetLatestInvoiceNumberResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.getLatestInvoiceNumber(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/invoices/get-latest-number',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateReceipt(): __PublicMethodMetaInfo<
  'POST',
  { invoiceId: string },
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.GenerateReceiptRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.GenerateReceiptRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.GenerateReceiptResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.GenerateReceiptResponse
> {
  const payload = { invoiceId: ':invoiceId' } as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.generateReceipt(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/invoices/{invoiceId}/generate-receipt',
    pathParams: { invoiceId: 'invoiceId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateInvoices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkCreateInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkCreateInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkCreateInvoicesResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkCreateInvoicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.bulkCreateInvoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/bulk/invoices/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateInvoices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkUpdateInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkUpdateInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkUpdateInvoicesResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkUpdateInvoicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.bulkUpdateInvoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/bulk/invoices/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteInvoices(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkDeleteInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkDeleteInvoicesRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkDeleteInvoicesResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkDeleteInvoicesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.bulkDeleteInvoices(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/bulk/invoices/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateInvoiceTags(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkUpdateInvoiceTagsRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkUpdateInvoiceTagsRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkUpdateInvoiceTagsResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkUpdateInvoiceTagsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.bulkUpdateInvoiceTags(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/bulk/invoices/update-tags',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateInvoiceTagsByFilter(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkUpdateInvoiceTagsByFilterRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkUpdateInvoiceTagsByFilterRequest,
  ambassadorWixInvoicesInvoicesV4InvoiceUniversalTypes.BulkUpdateInvoiceTagsByFilterResponse,
  ambassadorWixInvoicesInvoicesV4InvoiceTypes.BulkUpdateInvoiceTagsByFilterResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixInvoicesInvoicesV4Invoice.bulkUpdateInvoiceTagsByFilter(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v4/bulk/invoices/update-tags-by-filter',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Invoice as InvoiceOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  StatusQualifier as StatusQualifierOriginal,
  StatusQualifierWithLiterals as StatusQualifierWithLiteralsOriginal,
  Action as ActionOriginal,
  ActionWithLiterals as ActionWithLiteralsOriginal,
  SourceReference as SourceReferenceOriginal,
  Reference as ReferenceOriginal,
  ReferenceReferenceOptionsOneOf as ReferenceReferenceOptionsOneOfOriginal,
  ReferenceType as ReferenceTypeOriginal,
  ReferenceTypeWithLiterals as ReferenceTypeWithLiteralsOriginal,
  Standalone as StandaloneOriginal,
  Order as OrderOriginal,
  Migrated as MigratedOriginal,
  AutoCharge as AutoChargeOriginal,
  RegionalProperties as RegionalPropertiesOriginal,
  Locale as LocaleOriginal,
  Numbering as NumberingOriginal,
  CustomerInfo as CustomerInfoOriginal,
  FullAddressContactDetails as FullAddressContactDetailsOriginal,
  VatId as VatIdOriginal,
  VatType as VatTypeOriginal,
  VatTypeWithLiterals as VatTypeWithLiteralsOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  ShippingInfo as ShippingInfoOriginal,
  BusinessDetails as BusinessDetailsOriginal,
  LineItem as LineItemOriginal,
  LineItemLineItemOptionsOneOf as LineItemLineItemOptionsOneOfOriginal,
  LineItemType as LineItemTypeOriginal,
  LineItemTypeWithLiterals as LineItemTypeWithLiteralsOriginal,
  CustomItem as CustomItemOriginal,
  CatalogReference as CatalogReferenceOriginal,
  LineItemDiscount as LineItemDiscountOriginal,
  LineItemDiscountDiscountOptionsOneOf as LineItemDiscountDiscountOptionsOneOfOriginal,
  LineItemDiscountDiscountType as LineItemDiscountDiscountTypeOriginal,
  LineItemDiscountDiscountTypeWithLiterals as LineItemDiscountDiscountTypeWithLiteralsOriginal,
  LineItemTaxInfo as LineItemTaxInfoOriginal,
  LineItemTaxBreakdown as LineItemTaxBreakdownOriginal,
  LineItemTotals as LineItemTotalsOriginal,
  SubscriptionInfo as SubscriptionInfoOriginal,
  Cycle as CycleOriginal,
  CycleCycleOptionsOneOf as CycleCycleOptionsOneOfOriginal,
  Weekly as WeeklyOriginal,
  Monthly as MonthlyOriginal,
  Yearly as YearlyOriginal,
  CatalogItem as CatalogItemOriginal,
  ItemType as ItemTypeOriginal,
  ItemTypeItemTypeDataOneOf as ItemTypeItemTypeDataOneOfOriginal,
  PresetType as PresetTypeOriginal,
  PresetTypeWithLiterals as PresetTypeWithLiteralsOriginal,
  ShipmentInfo as ShipmentInfoOriginal,
  DeliveryLogistics as DeliveryLogisticsOriginal,
  DeliveryTimeSlot as DeliveryTimeSlotOriginal,
  PickupDetails as PickupDetailsOriginal,
  PickupMethod as PickupMethodOriginal,
  PickupMethodWithLiterals as PickupMethodWithLiteralsOriginal,
  ShipmentRegion as ShipmentRegionOriginal,
  ShipmentTaxInfo as ShipmentTaxInfoOriginal,
  ShipmentTaxBreakdown as ShipmentTaxBreakdownOriginal,
  ShipmentTotals as ShipmentTotalsOriginal,
  AdditionalFee as AdditionalFeeOriginal,
  AdditionalFeeSource as AdditionalFeeSourceOriginal,
  AdditionalFeeSourceWithLiterals as AdditionalFeeSourceWithLiteralsOriginal,
  Discount as DiscountOriginal,
  DiscountDiscountOptionsOneOf as DiscountDiscountOptionsOneOfOriginal,
  DiscountType as DiscountTypeOriginal,
  DiscountTypeWithLiterals as DiscountTypeWithLiteralsOriginal,
  Deposit as DepositOriginal,
  DepositDepositOptionsOneOf as DepositDepositOptionsOneOfOriginal,
  DepositType as DepositTypeOriginal,
  DepositTypeWithLiterals as DepositTypeWithLiteralsOriginal,
  TaxInfo as TaxInfoOriginal,
  TaxBreakdown as TaxBreakdownOriginal,
  Payment as PaymentOriginal,
  PaymentPaymentOptionsOneOf as PaymentPaymentOptionsOneOfOriginal,
  PaymentReceiptOptionsOneOf as PaymentReceiptOptionsOneOfOriginal,
  PaymentType as PaymentTypeOriginal,
  PaymentTypeWithLiterals as PaymentTypeWithLiteralsOriginal,
  RegularPaymentDetails as RegularPaymentDetailsOriginal,
  PaymentStatus as PaymentStatusOriginal,
  PaymentStatusWithLiterals as PaymentStatusWithLiteralsOriginal,
  CreditCardDetails as CreditCardDetailsOriginal,
  GiftCardPaymentDetails as GiftCardPaymentDetailsOriginal,
  ReceiptType as ReceiptTypeOriginal,
  ReceiptTypeWithLiterals as ReceiptTypeWithLiteralsOriginal,
  WixReceipt as WixReceiptOriginal,
  ExternalReceipt as ExternalReceiptOriginal,
  CashRounding as CashRoundingOriginal,
  Totals as TotalsOriginal,
  CustomFields as CustomFieldsOriginal,
  CustomField as CustomFieldOriginal,
  FooterContent as FooterContentOriginal,
  RichContent as RichContentOriginal,
  Node as NodeOriginal,
  NodeDataOneOf as NodeDataOneOfOriginal,
  NodeType as NodeTypeOriginal,
  NodeTypeWithLiterals as NodeTypeWithLiteralsOriginal,
  NodeStyle as NodeStyleOriginal,
  ButtonData as ButtonDataOriginal,
  BackgroundType as BackgroundTypeOriginal,
  BackgroundTypeWithLiterals as BackgroundTypeWithLiteralsOriginal,
  Gradient as GradientOriginal,
  GradientType as GradientTypeOriginal,
  GradientTypeWithLiterals as GradientTypeWithLiteralsOriginal,
  Stop as StopOriginal,
  Border as BorderOriginal,
  Colors as ColorsOriginal,
  Background as BackgroundOriginal,
  PluginContainerData as PluginContainerDataOriginal,
  WidthType as WidthTypeOriginal,
  WidthTypeWithLiterals as WidthTypeWithLiteralsOriginal,
  PluginContainerDataWidth as PluginContainerDataWidthOriginal,
  PluginContainerDataWidthDataOneOf as PluginContainerDataWidthDataOneOfOriginal,
  PluginContainerDataAlignment as PluginContainerDataAlignmentOriginal,
  PluginContainerDataAlignmentWithLiterals as PluginContainerDataAlignmentWithLiteralsOriginal,
  Spoiler as SpoilerOriginal,
  Height as HeightOriginal,
  ButtonDataType as ButtonDataTypeOriginal,
  ButtonDataTypeWithLiterals as ButtonDataTypeWithLiteralsOriginal,
  Styles as StylesOriginal,
  Link as LinkOriginal,
  LinkDataOneOf as LinkDataOneOfOriginal,
  Target as TargetOriginal,
  TargetWithLiterals as TargetWithLiteralsOriginal,
  Rel as RelOriginal,
  Animation as AnimationOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  EntranceAnimation as EntranceAnimationOriginal,
  EntranceEffect as EntranceEffectOriginal,
  EntranceEffectType as EntranceEffectTypeOriginal,
  EntranceEffectTypeWithLiterals as EntranceEffectTypeWithLiteralsOriginal,
  LoopAnimation as LoopAnimationOriginal,
  LoopEffect as LoopEffectOriginal,
  LoopEffectType as LoopEffectTypeOriginal,
  LoopEffectTypeWithLiterals as LoopEffectTypeWithLiteralsOriginal,
  PointerEffect as PointerEffectOriginal,
  PointerEffectType as PointerEffectTypeOriginal,
  PointerEffectTypeWithLiterals as PointerEffectTypeWithLiteralsOriginal,
  CodeBlockData as CodeBlockDataOriginal,
  TextStyle as TextStyleOriginal,
  TextAlignment as TextAlignmentOriginal,
  TextAlignmentWithLiterals as TextAlignmentWithLiteralsOriginal,
  DividerData as DividerDataOriginal,
  LineCap as LineCapOriginal,
  LineCapWithLiterals as LineCapWithLiteralsOriginal,
  LineStyle as LineStyleOriginal,
  LineStyleWithLiterals as LineStyleWithLiteralsOriginal,
  Width as WidthOriginal,
  WidthWithLiterals as WidthWithLiteralsOriginal,
  DividerDataAlignment as DividerDataAlignmentOriginal,
  DividerDataAlignmentWithLiterals as DividerDataAlignmentWithLiteralsOriginal,
  DividerDataStyles as DividerDataStylesOriginal,
  FileData as FileDataOriginal,
  ViewMode as ViewModeOriginal,
  ViewModeWithLiterals as ViewModeWithLiteralsOriginal,
  FileSource as FileSourceOriginal,
  FileSourceDataOneOf as FileSourceDataOneOfOriginal,
  PDFSettings as PDFSettingsOriginal,
  GalleryData as GalleryDataOriginal,
  Media as MediaOriginal,
  Image as ImageOriginal,
  Video as VideoOriginal,
  Item as ItemOriginal,
  ItemDataOneOf as ItemDataOneOfOriginal,
  GalleryOptions as GalleryOptionsOriginal,
  LayoutType as LayoutTypeOriginal,
  LayoutTypeWithLiterals as LayoutTypeWithLiteralsOriginal,
  Orientation as OrientationOriginal,
  OrientationWithLiterals as OrientationWithLiteralsOriginal,
  Crop as CropOriginal,
  CropWithLiterals as CropWithLiteralsOriginal,
  ThumbnailsAlignment as ThumbnailsAlignmentOriginal,
  ThumbnailsAlignmentWithLiterals as ThumbnailsAlignmentWithLiteralsOriginal,
  GalleryOptionsLayout as GalleryOptionsLayoutOriginal,
  ItemStyle as ItemStyleOriginal,
  Thumbnails as ThumbnailsOriginal,
  GIFData as GIFDataOriginal,
  GIF as GIFOriginal,
  GIFType as GIFTypeOriginal,
  GIFTypeWithLiterals as GIFTypeWithLiteralsOriginal,
  HeadingData as HeadingDataOriginal,
  HTMLData as HTMLDataOriginal,
  HTMLDataDataOneOf as HTMLDataDataOneOfOriginal,
  Source as SourceOriginal,
  SourceWithLiterals as SourceWithLiteralsOriginal,
  ImageData as ImageDataOriginal,
  StylesBorder as StylesBorderOriginal,
  ImageDataStyles as ImageDataStylesOriginal,
  ImageDataCrop as ImageDataCropOriginal,
  LinkPreviewData as LinkPreviewDataOriginal,
  StylesPosition as StylesPositionOriginal,
  StylesPositionWithLiterals as StylesPositionWithLiteralsOriginal,
  LinkPreviewDataStyles as LinkPreviewDataStylesOriginal,
  MapData as MapDataOriginal,
  MapSettings as MapSettingsOriginal,
  MapType as MapTypeOriginal,
  MapTypeWithLiterals as MapTypeWithLiteralsOriginal,
  ParagraphData as ParagraphDataOriginal,
  PollData as PollDataOriginal,
  ViewRole as ViewRoleOriginal,
  ViewRoleWithLiterals as ViewRoleWithLiteralsOriginal,
  VoteRole as VoteRoleOriginal,
  VoteRoleWithLiterals as VoteRoleWithLiteralsOriginal,
  Permissions as PermissionsOriginal,
  Option as OptionOriginal,
  Settings as SettingsOriginal,
  PollLayoutType as PollLayoutTypeOriginal,
  PollLayoutTypeWithLiterals as PollLayoutTypeWithLiteralsOriginal,
  PollLayoutDirection as PollLayoutDirectionOriginal,
  PollLayoutDirectionWithLiterals as PollLayoutDirectionWithLiteralsOriginal,
  PollLayout as PollLayoutOriginal,
  OptionLayout as OptionLayoutOriginal,
  PollDesignBackgroundType as PollDesignBackgroundTypeOriginal,
  PollDesignBackgroundTypeWithLiterals as PollDesignBackgroundTypeWithLiteralsOriginal,
  BackgroundGradient as BackgroundGradientOriginal,
  PollDesignBackground as PollDesignBackgroundOriginal,
  PollDesignBackgroundBackgroundOneOf as PollDesignBackgroundBackgroundOneOfOriginal,
  PollDesign as PollDesignOriginal,
  OptionDesign as OptionDesignOriginal,
  Poll as PollOriginal,
  PollDataLayout as PollDataLayoutOriginal,
  Design as DesignOriginal,
  TextData as TextDataOriginal,
  Decoration as DecorationOriginal,
  DecorationDataOneOf as DecorationDataOneOfOriginal,
  DecorationType as DecorationTypeOriginal,
  DecorationTypeWithLiterals as DecorationTypeWithLiteralsOriginal,
  AnchorData as AnchorDataOriginal,
  ColorData as ColorDataOriginal,
  LinkData as LinkDataOriginal,
  MentionData as MentionDataOriginal,
  FontSizeData as FontSizeDataOriginal,
  FontType as FontTypeOriginal,
  FontTypeWithLiterals as FontTypeWithLiteralsOriginal,
  SpoilerData as SpoilerDataOriginal,
  FontFamilyData as FontFamilyDataOriginal,
  SketchData as SketchDataOriginal,
  Variant as VariantOriginal,
  VariantWithLiterals as VariantWithLiteralsOriginal,
  AppEmbedData as AppEmbedDataOriginal,
  AppEmbedDataAppDataOneOf as AppEmbedDataAppDataOneOfOriginal,
  Position as PositionOriginal,
  PositionWithLiterals as PositionWithLiteralsOriginal,
  AspectRatio as AspectRatioOriginal,
  AspectRatioWithLiterals as AspectRatioWithLiteralsOriginal,
  Resizing as ResizingOriginal,
  ResizingWithLiterals as ResizingWithLiteralsOriginal,
  Placement as PlacementOriginal,
  PlacementWithLiterals as PlacementWithLiteralsOriginal,
  CardStylesType as CardStylesTypeOriginal,
  CardStylesTypeWithLiterals as CardStylesTypeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  Layout as LayoutOriginal,
  LayoutWithLiterals as LayoutWithLiteralsOriginal,
  AppType as AppTypeOriginal,
  AppTypeWithLiterals as AppTypeWithLiteralsOriginal,
  BookingData as BookingDataOriginal,
  EventData as EventDataOriginal,
  ButtonStyles as ButtonStylesOriginal,
  ImageStyles as ImageStylesOriginal,
  RibbonStyles as RibbonStylesOriginal,
  CardStyles as CardStylesOriginal,
  PricingData as PricingDataOriginal,
  VideoData as VideoDataOriginal,
  PlaybackOptions as PlaybackOptionsOriginal,
  EmbedData as EmbedDataOriginal,
  Oembed as OembedOriginal,
  CollapsibleListData as CollapsibleListDataOriginal,
  InitialExpandedItems as InitialExpandedItemsOriginal,
  InitialExpandedItemsWithLiterals as InitialExpandedItemsWithLiteralsOriginal,
  Direction as DirectionOriginal,
  DirectionWithLiterals as DirectionWithLiteralsOriginal,
  TableData as TableDataOriginal,
  Dimensions as DimensionsOriginal,
  TableCellData as TableCellDataOriginal,
  VerticalAlignment as VerticalAlignmentOriginal,
  VerticalAlignmentWithLiterals as VerticalAlignmentWithLiteralsOriginal,
  CellStyle as CellStyleOriginal,
  BorderColors as BorderColorsOriginal,
  BorderWidths as BorderWidthsOriginal,
  NullValue as NullValueOriginal,
  NullValueWithLiterals as NullValueWithLiteralsOriginal,
  ListValue as ListValueOriginal,
  AudioData as AudioDataOriginal,
  OrderedListData as OrderedListDataOriginal,
  BulletedListData as BulletedListDataOriginal,
  BlockquoteData as BlockquoteDataOriginal,
  CaptionData as CaptionDataOriginal,
  LayoutData as LayoutDataOriginal,
  ImageScalingScaling as ImageScalingScalingOriginal,
  ImageScalingScalingWithLiterals as ImageScalingScalingWithLiteralsOriginal,
  ImagePosition as ImagePositionOriginal,
  ImagePositionWithLiterals as ImagePositionWithLiteralsOriginal,
  LayoutDataBackground as LayoutDataBackgroundOriginal,
  LayoutDataBackgroundType as LayoutDataBackgroundTypeOriginal,
  LayoutDataBackgroundTypeWithLiterals as LayoutDataBackgroundTypeWithLiteralsOriginal,
  Origin as OriginOriginal,
  OriginWithLiterals as OriginWithLiteralsOriginal,
  BannerPosition as BannerPositionOriginal,
  BannerPositionWithLiterals as BannerPositionWithLiteralsOriginal,
  LayerEffect as LayerEffectOriginal,
  LayerEffectWithLiterals as LayerEffectWithLiteralsOriginal,
  Shape as ShapeOriginal,
  ShapeWithLiterals as ShapeWithLiteralsOriginal,
  Layers as LayersOriginal,
  BackdropType as BackdropTypeOriginal,
  BackdropTypeWithLiterals as BackdropTypeWithLiteralsOriginal,
  LayoutDataBackgroundImage as LayoutDataBackgroundImageOriginal,
  VerticalAlignmentAlignment as VerticalAlignmentAlignmentOriginal,
  VerticalAlignmentAlignmentWithLiterals as VerticalAlignmentAlignmentWithLiteralsOriginal,
  ResponsivenessBehaviour as ResponsivenessBehaviourOriginal,
  ResponsivenessBehaviourWithLiterals as ResponsivenessBehaviourWithLiteralsOriginal,
  DesignTarget as DesignTargetOriginal,
  DesignTargetWithLiterals as DesignTargetWithLiteralsOriginal,
  Banner as BannerOriginal,
  Backdrop as BackdropOriginal,
  SectionDivider as SectionDividerOriginal,
  LayoutCellData as LayoutCellDataOriginal,
  ShapeData as ShapeDataOriginal,
  ShapeDataStyles as ShapeDataStylesOriginal,
  CardData as CardDataOriginal,
  Scaling as ScalingOriginal,
  ScalingWithLiterals as ScalingWithLiteralsOriginal,
  ImagePositionPosition as ImagePositionPositionOriginal,
  ImagePositionPositionWithLiterals as ImagePositionPositionWithLiteralsOriginal,
  CardDataBackground as CardDataBackgroundOriginal,
  CardDataBackgroundType as CardDataBackgroundTypeOriginal,
  CardDataBackgroundTypeWithLiterals as CardDataBackgroundTypeWithLiteralsOriginal,
  BackgroundImage as BackgroundImageOriginal,
  TocData as TocDataOriginal,
  ListStyle as ListStyleOriginal,
  ListStyleWithLiterals as ListStyleWithLiteralsOriginal,
  Indentation as IndentationOriginal,
  IndentationWithLiterals as IndentationWithLiteralsOriginal,
  SmartBlockData as SmartBlockDataOriginal,
  SmartBlockDataType as SmartBlockDataTypeOriginal,
  SmartBlockDataTypeWithLiterals as SmartBlockDataTypeWithLiteralsOriginal,
  ColumnSize as ColumnSizeOriginal,
  ColumnSizeWithLiterals as ColumnSizeWithLiteralsOriginal,
  SmartBlockCellData as SmartBlockCellDataOriginal,
  CheckboxListData as CheckboxListDataOriginal,
  ListItemNodeData as ListItemNodeDataOriginal,
  Metadata as MetadataOriginal,
  DocumentStyle as DocumentStyleOriginal,
  TextNodeStyle as TextNodeStyleOriginal,
  PresetProperties as PresetPropertiesOriginal,
  InvoicePreset as InvoicePresetOriginal,
  DisplaySettings as DisplaySettingsOriginal,
  BusinessDisplayOptions as BusinessDisplayOptionsOriginal,
  CustomerDisplayOptions as CustomerDisplayOptionsOriginal,
  ItemsDisplayOptions as ItemsDisplayOptionsOriginal,
  TotalsDisplayOptions as TotalsDisplayOptionsOriginal,
  PaymentsDisplayOptions as PaymentsDisplayOptionsOriginal,
  DomainCustomFields as DomainCustomFieldsOriginal,
  DomainCustomField as DomainCustomFieldOriginal,
  CustomFieldPlaceholder as CustomFieldPlaceholderOriginal,
  DisplayValues as DisplayValuesOriginal,
  Attachment as AttachmentOriginal,
  DocumentInfo as DocumentInfoOriginal,
  DocumentStatus as DocumentStatusOriginal,
  DocumentStatusWithLiterals as DocumentStatusWithLiteralsOriginal,
  Links as LinksOriginal,
  BusinessLocation as BusinessLocationOriginal,
  ActivityInfo as ActivityInfoOriginal,
  Tags as TagsOriginal,
  TagList as TagListOriginal,
  InvoiceNumberingProcess as InvoiceNumberingProcessOriginal,
  InvoiceDocumentProcess as InvoiceDocumentProcessOriginal,
  InvoiceDocumentHandled as InvoiceDocumentHandledOriginal,
  InvoiceDocumentHandledResultOneOf as InvoiceDocumentHandledResultOneOfOriginal,
  Succeeded as SucceededOriginal,
  Failed as FailedOriginal,
  MediaFileStateChanged as MediaFileStateChangedOriginal,
  FileState as FileStateOriginal,
  FileStateWithLiterals as FileStateWithLiteralsOriginal,
  SideEffectsTriggerRequested as SideEffectsTriggerRequestedOriginal,
  SiteTaxesMigrationRequested as SiteTaxesMigrationRequestedOriginal,
  TagsModified as TagsModifiedOriginal,
  InvoiceSent as InvoiceSentOriginal,
  CreateInvoiceRequest as CreateInvoiceRequestOriginal,
  CreateInvoiceResponse as CreateInvoiceResponseOriginal,
  GetInvoiceRequest as GetInvoiceRequestOriginal,
  GetInvoiceResponse as GetInvoiceResponseOriginal,
  UpdateInvoiceRequest as UpdateInvoiceRequestOriginal,
  UpdateInvoiceResponse as UpdateInvoiceResponseOriginal,
  IllegalActionErrorData as IllegalActionErrorDataOriginal,
  ErrorType as ErrorTypeOriginal,
  ErrorTypeWithLiterals as ErrorTypeWithLiteralsOriginal,
  ConvertInvoiceRequest as ConvertInvoiceRequestOriginal,
  ConvertInvoiceResponse as ConvertInvoiceResponseOriginal,
  DeleteInvoiceRequest as DeleteInvoiceRequestOriginal,
  DeleteInvoiceResponse as DeleteInvoiceResponseOriginal,
  QueryInvoicesRequest as QueryInvoicesRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryInvoicesResponse as QueryInvoicesResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  SearchInvoicesRequest as SearchInvoicesRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  Interval as IntervalOriginal,
  IntervalWithLiterals as IntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  GroupByAggregation as GroupByAggregationOriginal,
  GroupByAggregationKindOneOf as GroupByAggregationKindOneOfOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchInvoicesResponse as SearchInvoicesResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  SendInvoiceRequest as SendInvoiceRequestOriginal,
  SendInvoiceResponse as SendInvoiceResponseOriginal,
  SendResult as SendResultOriginal,
  SendErrorType as SendErrorTypeOriginal,
  SendErrorTypeWithLiterals as SendErrorTypeWithLiteralsOriginal,
  PublishInvoiceRequest as PublishInvoiceRequestOriginal,
  PublishInvoiceResponse as PublishInvoiceResponseOriginal,
  VoidInvoiceRequest as VoidInvoiceRequestOriginal,
  VoidInvoiceResponse as VoidInvoiceResponseOriginal,
  ArchiveInvoiceRequest as ArchiveInvoiceRequestOriginal,
  ArchiveInvoiceResponse as ArchiveInvoiceResponseOriginal,
  UnarchiveInvoiceRequest as UnarchiveInvoiceRequestOriginal,
  UnarchiveInvoiceResponse as UnarchiveInvoiceResponseOriginal,
  InitiatePaymentRequest as InitiatePaymentRequestOriginal,
  InitiatePaymentResponse as InitiatePaymentResponseOriginal,
  EnableInvoicePaymentsRequest as EnableInvoicePaymentsRequestOriginal,
  EnableInvoicePaymentsResponse as EnableInvoicePaymentsResponseOriginal,
  GeneratePdfDocumentRequest as GeneratePdfDocumentRequestOriginal,
  GeneratePdfDocumentResponse as GeneratePdfDocumentResponseOriginal,
  MarkInvoiceAsViewedRequest as MarkInvoiceAsViewedRequestOriginal,
  MarkInvoiceAsViewedResponse as MarkInvoiceAsViewedResponseOriginal,
  MarkInvoiceAsSentRequest as MarkInvoiceAsSentRequestOriginal,
  MarkInvoiceAsSentResponse as MarkInvoiceAsSentResponseOriginal,
  CalculateInvoiceRequest as CalculateInvoiceRequestOriginal,
  CalculateInvoiceResponse as CalculateInvoiceResponseOriginal,
  ShipmentOption as ShipmentOptionOriginal,
  DeliveryLogisticsOption as DeliveryLogisticsOptionOriginal,
  CalculationErrors as CalculationErrorsOriginal,
  CalculationErrorsShippingCalculationErrorOneOf as CalculationErrorsShippingCalculationErrorOneOfOriginal,
  Details as DetailsOriginal,
  DetailsKindOneOf as DetailsKindOneOfOriginal,
  ApplicationError as ApplicationErrorOriginal,
  ValidationError as ValidationErrorOriginal,
  RuleType as RuleTypeOriginal,
  RuleTypeWithLiterals as RuleTypeWithLiteralsOriginal,
  FieldViolation as FieldViolationOriginal,
  SystemError as SystemErrorOriginal,
  CarrierErrors as CarrierErrorsOriginal,
  CarrierError as CarrierErrorOriginal,
  GetLatestInvoiceNumberRequest as GetLatestInvoiceNumberRequestOriginal,
  GetLatestInvoiceNumberResponse as GetLatestInvoiceNumberResponseOriginal,
  InternalCountInvoicesRequest as InternalCountInvoicesRequestOriginal,
  InternalCountInvoicesResponse as InternalCountInvoicesResponseOriginal,
  GenerateReceiptRequest as GenerateReceiptRequestOriginal,
  GenerateReceiptResponse as GenerateReceiptResponseOriginal,
  BulkCreateInvoicesRequest as BulkCreateInvoicesRequestOriginal,
  BulkCreateInvoicesResponse as BulkCreateInvoicesResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  BulkInvoiceResult as BulkInvoiceResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateInvoicesRequest as BulkUpdateInvoicesRequestOriginal,
  MaskedInvoice as MaskedInvoiceOriginal,
  BulkUpdateInvoicesResponse as BulkUpdateInvoicesResponseOriginal,
  BulkUpdateInvoicesResponseBulkInvoiceResult as BulkUpdateInvoicesResponseBulkInvoiceResultOriginal,
  BulkDeleteInvoicesRequest as BulkDeleteInvoicesRequestOriginal,
  BulkDeleteInvoicesResponse as BulkDeleteInvoicesResponseOriginal,
  BulkDeleteInvoicesResponseBulkInvoiceResult as BulkDeleteInvoicesResponseBulkInvoiceResultOriginal,
  BulkUpdateInvoiceTagsRequest as BulkUpdateInvoiceTagsRequestOriginal,
  BulkUpdateInvoiceTagsResponse as BulkUpdateInvoiceTagsResponseOriginal,
  BulkUpdateInvoiceTagsResult as BulkUpdateInvoiceTagsResultOriginal,
  BulkUpdateInvoiceTagsByFilterRequest as BulkUpdateInvoiceTagsByFilterRequestOriginal,
  BulkUpdateInvoiceTagsByFilterResponse as BulkUpdateInvoiceTagsByFilterResponseOriginal,
  AddPaymentRequest as AddPaymentRequestOriginal,
  AddPaymentResponse as AddPaymentResponseOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  CreateInvoiceApplicationErrors as CreateInvoiceApplicationErrorsOriginal,
  CreateInvoiceValidationErrors as CreateInvoiceValidationErrorsOriginal,
  GetInvoiceApplicationErrors as GetInvoiceApplicationErrorsOriginal,
  UpdateInvoiceApplicationErrors as UpdateInvoiceApplicationErrorsOriginal,
  UpdateInvoiceValidationErrors as UpdateInvoiceValidationErrorsOriginal,
  DeleteInvoiceApplicationErrors as DeleteInvoiceApplicationErrorsOriginal,
  QueryInvoicesApplicationErrors as QueryInvoicesApplicationErrorsOriginal,
  SendInvoiceApplicationErrors as SendInvoiceApplicationErrorsOriginal,
  PublishInvoiceApplicationErrors as PublishInvoiceApplicationErrorsOriginal,
  VoidInvoiceApplicationErrors as VoidInvoiceApplicationErrorsOriginal,
  ArchiveInvoiceApplicationErrors as ArchiveInvoiceApplicationErrorsOriginal,
  UnarchiveInvoiceApplicationErrors as UnarchiveInvoiceApplicationErrorsOriginal,
  InitiatePaymentApplicationErrors as InitiatePaymentApplicationErrorsOriginal,
  EnableInvoicePaymentsApplicationErrors as EnableInvoicePaymentsApplicationErrorsOriginal,
  GeneratePdfDocumentApplicationErrors as GeneratePdfDocumentApplicationErrorsOriginal,
  CalculateInvoiceApplicationErrors as CalculateInvoiceApplicationErrorsOriginal,
  BulkCreateInvoicesApplicationErrors as BulkCreateInvoicesApplicationErrorsOriginal,
  BulkCreateInvoicesValidationErrors as BulkCreateInvoicesValidationErrorsOriginal,
  BulkUpdateInvoicesApplicationErrors as BulkUpdateInvoicesApplicationErrorsOriginal,
  BulkUpdateInvoicesValidationErrors as BulkUpdateInvoicesValidationErrorsOriginal,
  BulkUpdateInvoiceTagsApplicationErrors as BulkUpdateInvoiceTagsApplicationErrorsOriginal,
  BulkUpdateInvoiceTagsByFilterApplicationErrors as BulkUpdateInvoiceTagsByFilterApplicationErrorsOriginal,
} from './invoices-invoices-v4-invoice-invoices.types.js';
